import http from './http';

import { createLogger } from '../utils/logger';

const logger = createLogger('organDonor');
export interface OrganDonorRec {
  id: string;
  userId: string;
  taskId: number;
  isOrganDonor?: boolean;
  isRegisteredDonor?: boolean;
  interestedInBecomingDonor?: boolean;
  donorRegistry?: string;
  organsTissues?: string;
  restrictions?: string;
  emergencyContact?: string;
  contactPhone?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

class OrganDonorInfoService {
  async getAllOrganDonor(targetUserId?: string): Promise<OrganDonorRec[]> {
    try {
      const params = targetUserId ? `?targetUserId=${targetUserId}` : '';
      const res = await http.get(`/api/organ-donor${params}`);
      return res.data;
    } catch (error) {
      logger.error('Error fetching organ donor info:', error);
      return [];
    }
  }

  async getOrganDonorById(id: string): Promise<OrganDonorRec | null> {
    try {
      const res = await http.get(`/api/organ-donor/${id}`);
      return res.data;
    } catch (error) {
      logger.error('Error fetching organ donor info by ID:', error);
      return null;
    }
  }

  async getOrganDonorByTaskId(taskId: number): Promise<OrganDonorRec[]> {
    try {
      const res = await http.get(`/api/organ-donor?taskId=${taskId}`);
      return res.data;
    } catch (error) {
      logger.error('Error fetching organ donor info by task ID:', error);
      return [];
    }
  }

  async createOrganDonor(data: Partial<OrganDonorRec>): Promise<OrganDonorRec> {
    const res = await http.post('/api/organ-donor', data);
    return res.data;
  }

  async updateOrganDonor(id: string, data: Partial<OrganDonorRec>): Promise<OrganDonorRec> {
    const res = await http.patch(`/api/organ-donor/${id}`, data);
    return res.data;
  }

  async deleteOrganDonor(id: string): Promise<void> {
    await http.delete(`/api/organ-donor/${id}`);
  }

  async lockOrganDonor(id: string): Promise<void> {
    const res = await http.post(`/api/organ-donor/${id}/lock`);
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`Failed to lock organ donor info: ${res.status}`);
    }
  }

  async unlockOrganDonor(id: string, granteeEmails: string[]): Promise<void> {
    const res = await http.post(`/api/organ-donor/${id}/unlock`, { granteeEmails });
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`Failed to unlock organ donor info: ${res.status}`);
    }
  }

  async getOrganDonorAccessGrants(id: string): Promise<any[]> {
    try {
      const res = await http.get(`/api/organ-donor/${id}/access-grants`);
      return res.data || [];
    } catch (error) {
      logger.error('Error fetching organ donor access grants:', error);
      throw new Error(`Failed to get organ donor access grants: ${error}`);
    }
  }

}

export const organDonorService = new OrganDonorInfoService();